<template>
<div>
  <Select v-model="chgoptions" class="left btnarea" style="width:120px;">
    <Option
      v-for="item in selectOption"
      :class="item.thame"
      :value="item.value"
      :key="item.value"
    >{{ item.label }}</Option>
  </Select>
</div>
</template>
<script>
import selectAllupch from "./SelectAllupch";
export default {
  mixins: [selectAllupch],
  data() {
    return {
      select1: [
        { value: 60, label: "全部" },
        { value: 36, proj: 1, label: "生肖中" },
        { value: 37, proj: 1, label: "生肖不中" },
        { value: 38, proj: 2, label: "尾数" },
        { value: 39, proj: 3, label: "特码六肖" },
        { value: 62, proj: 4, label: '肖總量' }
      ],
      select2: [
        { value: 60, label: "全部" },
        { value: 63, proj: 5, label: "1肖数" },
        { value: 64, proj: 5, label: "2肖数" },
        { value: 65, proj: 5, label: "3肖数" },
        { value: 66, proj: 5, label: "4肖数" }
      ],
      select3: [
        { value: 60, label: "全部" },
        { value: 40, label: "二肖连中" },
        { value: 41, label: "二肖连不中" },
        { value: 42, label: "三肖连中" },
        { value: 43, label: "三肖连不中" },
        { value: 44, label: "四肖连中" },
        { value: 45, label: "四肖连不中" },
        { value: 46, label: "五肖连中" },
        { value: 47, label: "五肖连不中" }
      ],
      select4: [
        { value: 60, label: "全部" },
        { value: 48, label: "二尾连中" },
        { value: 49, label: "二尾连不中" },
        { value: 50, label: "三尾连中" },
        { value: 51, label: "三尾连不中" },
        { value: 52, label: "四尾连中" },
        { value: 53, label: "四尾连不中" },
        { value: 87, label: "五尾连中" },
        { value: 88, label: "五尾连不中" }
      ],
      select5: [
        { value: 54, label: "特码生肖" },
        { value: 55, label: "特码半波单双" },
        { value: 56, label: "特码半波大小" },
        { value: 67, label: "正特两面色波" },
        // { value: 57, label: "过关" }
      ]
    };
  },
  computed: {
    chgoptions: {
      get() {
        return this.getliveshow.oddItemSelect.option;
      },
      set(val) {
        if (val == undefined) return
        const obj = { option: val }
        const find = this.selectOption.find(it => it.value === val)
        const option = { ...find }
        if (option && option.hasOwnProperty('proj')) { obj['proj'] = option.proj }
        this.upDate_oddItemSelect(obj);
      }
    },
    selectOption() {
      const page = this.$route.meta.page;
      if (page == 9) {
        if (this.getliveshow.proj == 1) {
          return this.select1
        } else {
          return this.select2
        }
      } else if (page == 11) {
        return this.select3
      } else if (page == 12) {
        return this.select4
      } else if (page == 16) {
        return this.select5
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.upDate_oddItemSelect({ option: this.selectOption[0].value });
    }
  },
  mounted () {
    this.upDate_oddItemSelect({ option: this.selectOption[0].value });
  },
};
</script>